import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content title"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, "推荐一 ", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, "推荐二 ", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, "推荐三 ", -1);
const _hoisted_5 = {
  class: "content",
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_6 = {
  class: "content",
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_7 = {
  class: "content",
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "时间 ", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "0球 ", -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "1球 ", -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "2球 ", -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "3球 ", -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "4球 ", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "5球 ", -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "6+球 ", -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "初离散 ", -1);
const _hoisted_17 = {
  class: "contentWater"
};
const _hoisted_18 = {
  class: "contentWater"
};
const _hoisted_19 = {
  class: "contentWater"
};
const _hoisted_20 = {
  class: "contentWater"
};
const _hoisted_21 = {
  class: "contentWater"
};
const _hoisted_22 = {
  class: "contentWater"
};
const _hoisted_23 = {
  class: "contentWater"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "终离散 ", -1);
const _hoisted_25 = {
  class: "contentWater"
};
const _hoisted_26 = {
  class: "contentWater"
};
const _hoisted_27 = {
  class: "contentWater"
};
const _hoisted_28 = {
  class: "contentWater"
};
const _hoisted_29 = {
  class: "contentWater"
};
const _hoisted_30 = {
  class: "contentWater"
};
const _hoisted_31 = {
  class: "contentWater"
};
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
import TtgConvert from './TtgConvert.vue';
import CrsConvert from './CrsConvert.vue';
import LoadingView from './LoadingView.vue';
import { decryptData } from './calculation.js';
export default {
  __name: 'AnalyzeTtgView',
  setup(__props, {
    expose: __expose
  }) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const title = ref('');
    const isListVisible = ref(false);
    // 显示弹出框
    const show = matchId => {
      isListVisible.value = true;
      getFixedBonusV1(matchId);
    };
    const oddsHistory = ref({});
    const ttgRef = ref(null);
    const crsRef = ref(null);
    const loadingRef = ref(null);
    const bigData = ref([]);
    const stdevpData = ref([{}, {}]);
    const goalLine = ref("");
    const getFixedBonusV1 = async matchId => {
      try {
        loadingRef.value.show();
        bigData.value = [];
        stdevpData.value = [{}, {}];
        const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getFixedBonusV1.qry?clientCode=3001&matchId=' + matchId);
        let data = response.data;
        if (data.success) {
          oddsHistory.value = data.value.oddsHistory;
          goalLine.value = oddsHistory.value.hhadList[0].goalLine;
          title.value = oddsHistory.value.homeTeamAbbName + ' VS ' + oddsHistory.value.awayTeamAbbName;
          if (data.value.sectionsNo999 != '') {
            title.value = oddsHistory.value.homeTeamAbbName + ' ' + data.value.sectionsNo999 + ' ' + oddsHistory.value.awayTeamAbbName;
          }
          //const response1 = axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/getMatchGoalWater?&crsSize=' + 0 + "&ttgSize=" + 0, data.value);
          //const response2 = axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/getMatchGoalWater', data.value);
          const response3 = axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/getCombination', data.value);
          const response4 = axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/getMatchGoalSTDEVP', data.value);
          const response5 = axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/selectMatchGoalWaterList', data.value);
          const response6 = axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/selectMatchGoalWaterList?crsFlag=true', data.value);
          // const response1 = axios.post('http://localhost:8888/matchGoalWater/getMatchGoalWater?&crsSize=' + 0 + "&ttgSize=" + 0, data.value);
          // const response2 = axios.post('http://localhost:8888/matchGoalWater/getMatchGoalWater', data.value);
          //const response3 = axios.post('http://localhost:8888/matchGoalWater/getCombination', data.value);
          //const response4 = axios.post('http://localhost:8888/matchGoalWater/getMatchGoalSTDEVP', data.value);
          //const response5 = axios.post('http://localhost:8888/matchGoalWater/selectMatchGoalWaterList', data.value);
          //const response6 = axios.post('http://localhost:8888/matchGoalWater/selectMatchGoalWaterList?crsFlag=true', data.value);
          // 使用Promise.all同时发送请求
          Promise.all([response3, response4, response5, response6]).then(axiosResponses => {
            // 所有请求都成功了
            let data5 = decryptData(axiosResponses[2].data);
            let data6 = decryptData(axiosResponses[3].data);
            console.log(data5);
            console.log(data6);
            //let data1 = decryptData(axiosResponses[0].data);
            //let data2 = decryptData(axiosResponses[1].data);
            ttgRef.value.pushTtgList(oddsHistory.value.ttgList, matchId, data5.ttg, data.value);
            crsRef.value.pushCrsList(oddsHistory.value.crsList, matchId, data5.crs, data5.ttg, data6.crs, data.value);
            let data3 = decryptData(axiosResponses[0].data);
            bigData.value = data3;
            let data4 = decryptData(axiosResponses[1].data);
            stdevpData.value = data4;
            loadingRef.value.close();
          }).catch(error => {
            // 至少一个请求失败了
            console.error('一个请求失败了:', error);
            loadingRef.value.close();
          });
        } else {
          loadingRef.value.close();
          timeNotify(data.errorMessage);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
        loadingRef.value.close();
      }
    };

    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(LoadingView, {
        ref_key: "loadingRef",
        ref: loadingRef
      }, null, 512), _createVNode(_component_nut_popup, {
        visible: isListVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isListVisible.value = $event),
        closeable: "",
        style: {
          padding: '30px 10px',
          height: '85%',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, "(" + _toDisplayString(goalLine.value) + ")" + _toDisplayString(title.value), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode("大数据分析推荐(括号内为出现次数)")]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [bigData.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(bigData.value[0].combination) + " 球 （" + _toDisplayString(bigData.value[0].count) + "）", 1)], 64)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [bigData.value.length > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(bigData.value[1].combination) + " 球 （" + _toDisplayString(bigData.value[1].count) + "）", 1)], 64)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [bigData.value.length > 2 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(bigData.value[2].combination) + " 球 （" + _toDisplayString(bigData.value[2].count) + "）", 1)], 64)) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode("离散分析推荐(数值越小越好)")]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_11]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_13]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_15]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_16]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_17, _toDisplayString(stdevpData.value[0].s0), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(stdevpData.value[0].s1), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_19, _toDisplayString(stdevpData.value[0].s2), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString(stdevpData.value[0].s3), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_21, _toDisplayString(stdevpData.value[0].s4), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString(stdevpData.value[0].s5), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(stdevpData.value[0].s6), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_hoisted_24]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(stdevpData.value[1].s0), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_26, _toDisplayString(stdevpData.value[1].s1), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_27, _toDisplayString(stdevpData.value[1].s2), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_28, _toDisplayString(stdevpData.value[1].s3), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_29, _toDisplayString(stdevpData.value[1].s4), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_30, _toDisplayString(stdevpData.value[1].s5), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_31, _toDisplayString(stdevpData.value[1].s6), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(TtgConvert, {
          ref_key: "ttgRef",
          ref: ttgRef
        }, null, 512), _createVNode(CrsConvert, {
          ref_key: "crsRef",
          ref: crsRef
        }, null, 512)]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
};